// src/enums/account.ts
var AccountSide = /* @__PURE__ */ ((AccountSide2) => {
  AccountSide2["CHAN"] = "CHAN";
  AccountSide2["LE"] = "LE";
  return AccountSide2;
})(AccountSide || {});

// src/enums/game.ts
var XOC_DIA_KEYS = [
  "CHAN" /* CHAN */,
  "LE" /* LE */,
  "4T" /* _4T */,
  "4D" /* _4D */,
  "3T1D" /* _3T1D */,
  "3D1T" /* _3D1T */,
  "2D2T" /* _2D2T */
];
var BAU_CUA_KEYS = [
  "BAU" /* BAU */,
  "CUA" /* CUA */,
  "CA" /* CA */,
  "TOM" /* TOM */,
  "GA" /* GA */,
  "NAI" /* NAI */
];
var BET_KEYS_BY_GAME = {
  ["TX" /* TX */]: ["TAI" /* TAI */, "XIU" /* XIU */],
  ["XD" /* XD */]: XOC_DIA_KEYS,
  ["XDMD5" /* XDMD5 */]: XOC_DIA_KEYS,
  ["BAUCUA" /* BAUCUA */]: BAU_CUA_KEYS
};

// src/constants/side-doors.ts
var BET_KEY_LABELS = Object.freeze({
  ["TAI" /* TAI */]: "T\xE0i",
  ["XIU" /* XIU */]: "X\u1EC9u",
  ["CHAN" /* CHAN */]: "Ch\u1EB5n",
  ["LE" /* LE */]: "L\u1EBB",
  ["4T" /* _4T */]: "4 Tr\u1EAFng",
  ["4D" /* _4D */]: "4 \u0110\u1ECF",
  ["3T1D" /* _3T1D */]: "3 Tr\u1EAFng",
  ["3D1T" /* _3D1T */]: "3 \u0110\u1ECF",
  ["2D2T" /* _2D2T */]: "2 \u0110\u1ECF 2 Tr\u1EAFng",
  ["BAU" /* BAU */]: "B\u1EA7u",
  ["CUA" /* CUA */]: "Cua",
  ["CA" /* CA */]: "C\xE1",
  ["TOM" /* TOM */]: "T\xF4m",
  ["GA" /* GA */]: "G\xE0",
  ["NAI" /* NAI */]: "Nai"
});
var SIDE_NAMES = Object.freeze({
  ["CHAN" /* CHAN */]: "Phe A",
  ["LE" /* LE */]: "Phe B"
});
var SPRAY_COINS_BY_GAME = Object.freeze({
  ["TX" /* TX */]: Object.freeze([1e3, 5e3, 1e4, 5e4, 1e5, 5e5]),
  ["XD" /* XD */]: Object.freeze([1e3, 5e3, 1e4, 5e4, 1e5, 5e5]),
  ["XDMD5" /* XDMD5 */]: Object.freeze([1e3, 5e3, 1e4, 5e4, 1e5, 5e5]),
  // Khớp BAUCUA_CHIPS (game-sdk): 500 · 1k · 5k · 10k · 50k — không có chip 100k/500k.
  ["BAUCUA" /* BAUCUA */]: Object.freeze([500, 1e3, 5e3, 1e4, 5e4])
});
function minCoinOf(gameType) {
  return Math.min(...SPRAY_COINS_BY_GAME[gameType]);
}
function perAccountFloorUnits(ratios) {
  if (ratios.length <= 1) return 1;
  return ratios.reduce((sum, item) => sum + item.ratio, 0);
}

// src/utils/group.ts
var REQUIRED_GROUP_MEMBERS = 4;
function groupIssues(shape) {
  const issues = [];
  if (shape.memberCount !== REQUIRED_GROUP_MEMBERS) {
    issues.push(
      `c\u1EA7n \u0111\xFAng ${String(REQUIRED_GROUP_MEMBERS)} t\xE0i kho\u1EA3n (\u0111ang c\xF3 ${String(shape.memberCount)})`
    );
  }
  const minCoin = minCoinOf(shape.gameType);
  for (const side of Object.values(AccountSide)) {
    const name = SIDE_NAMES[side].replace("Phe", "phe");
    if (sideTotal(shape.sideConfigs, side) <= 0) {
      issues.push(`ch\u01B0a \u0111\u1EB7t ti\u1EC1n ${name}`);
      continue;
    }
    for (const door of sideDoors(shape.sideConfigs, side)) {
      if (door.amount > 0 && door.amount % minCoin !== 0) {
        issues.push(
          `c\u1EEDa ${BET_KEY_LABELS[door.key]} ${name} ph\u1EA3i l\xE0 b\u1ED9i s\u1ED1 c\u1EE7a ${minCoin.toLocaleString("vi-VN")}`
        );
      }
    }
  }
  return issues;
}
function sideImbalanceWarning(shape) {
  const a = sideTotal(shape.sideConfigs, "CHAN" /* CHAN */);
  const b = sideTotal(shape.sideConfigs, "LE" /* LE */);
  if (a <= 0 || b <= 0 || a === b) return null;
  const gap = Math.abs(a - b);
  const heavier = a > b ? SIDE_NAMES["CHAN" /* CHAN */] : SIDE_NAMES["LE" /* LE */];
  return `Hai phe l\u1EC7ch ${gap.toLocaleString("vi-VN")} \u2014 ph\u1EA7n ch\xEAnh nghi\xEAng v\u1EC1 ${heavier} kh\xF4ng c\xF3 g\xEC \u0111\u1ED1i \u1EE9ng, th\u1EAFng thua \u0103n nguy\xEAn.`;
}
var OPPOSING_FAMILIES = {
  TX: [["TAI" /* TAI */], ["XIU" /* XIU */]],
  XD: [
    ["CHAN" /* CHAN */, "4T" /* _4T */, "4D" /* _4D */, "2D2T" /* _2D2T */],
    ["LE" /* LE */, "3D1T" /* _3D1T */, "3T1D" /* _3T1D */]
  ],
  XDMD5: [
    ["CHAN" /* CHAN */, "4T" /* _4T */, "4D" /* _4D */, "2D2T" /* _2D2T */],
    ["LE" /* LE */, "3D1T" /* _3D1T */, "3T1D" /* _3T1D */]
  ]
};
function doorExposureWarning(shape) {
  const families = OPPOSING_FAMILIES[shape.gameType];
  if (!families) return null;
  const totalOf = (keys) => keys.reduce(
    (sum, key) => sum + Object.values(AccountSide).reduce(
      (inner, side) => inner + doorAmount(shape.sideConfigs, side, key),
      0
    ),
    0
  );
  const [first, second] = families;
  const a = totalOf(first);
  const b = totalOf(second);
  if (a <= 0 && b <= 0 || a === b) return null;
  const describe = (keys, total) => {
    const names = keys.map((key) => BET_KEY_LABELS[key]);
    const family = names[0] ?? "";
    return keys.length === 1 ? `${family} (${total.toLocaleString("vi-VN")})` : `h\u1ECD ${family} (${names.join(" + ")}) (${total.toLocaleString("vi-VN")})`;
  };
  const gap = Math.abs(a - b);
  const heavier = a > b ? first : second;
  const heavierName = BET_KEY_LABELS[heavier[0] ?? "CHAN" /* CHAN */];
  return `C\u01B0\u1EE3c tr\u1EA7n: t\u1ED5ng ${describe(first, a)} kh\xE1c t\u1ED5ng ${describe(second, b)} \u2014 ph\u1EA7n ch\xEAnh ${gap.toLocaleString("vi-VN")} nghi\xEAng v\u1EC1 ${heavier.length === 1 ? "" : "h\u1ECD "}${heavierName}, kh\xF4ng c\xF3 g\xEC \u0111\u1ED1i \u1EE9ng.`;
}
function unsplittableSideWarning(shape) {
  const warnings = [];
  const minCoin = minCoinOf(shape.gameType);
  for (const side of Object.values(AccountSide)) {
    const total = sideTotal(shape.sideConfigs, side);
    if (total <= 0) continue;
    const need = perAccountFloorUnits(sideKeyRatios(shape.sideConfigs, side));
    const units = Math.floor(total / minCoin);
    if (units >= 2 * need) continue;
    warnings.push(
      `${SIDE_NAMES[side]} ch\u1EC9 c\xF3 ${String(units)} \u0111\u01A1n v\u1ECB (${total.toLocaleString("vi-VN")}) n\xEAn kh\xF4ng chia n\u1ED5i cho c\u1EA3 2 t\xE0i kho\u1EA3n (c\u1EA7n t\u1ED1i thi\u1EC3u ${String(2 * need)}) \u2014 khi ch\u1EA1y ch\u1EC9 1 t\xE0i kho\u1EA3n c\u1EE7a phe n\xE0y \u0111\xE1nh. T\u0103ng ti\u1EC1n ho\u1EB7c l\xE0m tr\xF2n c\xE1c c\u1EEDa v\u1EC1 b\u1ED9i chung l\u1EDBn h\u01A1n.`
    );
  }
  return warnings;
}
function isGroupRunnable(shape) {
  return groupIssues(shape).length === 0;
}
function sideDoors(sideConfigs, side) {
  return sideConfigs?.find((config) => config.side === side)?.doors ?? [];
}
function doorAmount(sideConfigs, side, key) {
  return sideDoors(sideConfigs, side).find((door) => door.key === key)?.amount ?? 0;
}
function sideTotal(sideConfigs, side) {
  return sideDoors(sideConfigs, side).reduce(
    (sum, door) => sum + (door.amount > 0 ? door.amount : 0),
    0
  );
}
function gcd(a, b) {
  return b === 0 ? a : gcd(b, a % b);
}
function sideKeyRatios(sideConfigs, side) {
  const active = sideDoors(sideConfigs, side).filter((door) => door.amount > 0);
  const divisor = active.reduce((acc, door) => gcd(acc, door.amount), 0);
  if (divisor <= 0) return [];
  return active.map((door) => ({ key: door.key, ratio: door.amount / divisor }));
}
var LEGACY_DOORS = {
  TX: {
    ["CHAN" /* CHAN */]: [{ key: "TAI" /* TAI */, ratio: 1 }],
    ["LE" /* LE */]: [{ key: "XIU" /* XIU */, ratio: 1 }]
  },
  XD: {
    ["CHAN" /* CHAN */]: [{ key: "CHAN" /* CHAN */, ratio: 1 }],
    ["LE" /* LE */]: [
      { key: "LE" /* LE */, ratio: 2 },
      { key: "3D1T" /* _3D1T */, ratio: 1 },
      { key: "3T1D" /* _3T1D */, ratio: 1 }
    ]
  },
  XDMD5: {
    ["CHAN" /* CHAN */]: [{ key: "CHAN" /* CHAN */, ratio: 1 }],
    ["LE" /* LE */]: [
      { key: "LE" /* LE */, ratio: 2 },
      { key: "3D1T" /* _3D1T */, ratio: 1 },
      { key: "3T1D" /* _3T1D */, ratio: 1 }
    ]
  },
  BAUCUA: {
    ["CHAN" /* CHAN */]: [
      { key: "BAU" /* BAU */, ratio: 1 },
      { key: "CUA" /* CUA */, ratio: 1 },
      { key: "CA" /* CA */, ratio: 1 }
    ],
    ["LE" /* LE */]: [
      { key: "TOM" /* TOM */, ratio: 1 },
      { key: "GA" /* GA */, ratio: 1 },
      { key: "NAI" /* NAI */, ratio: 1 }
    ]
  }
};
function legacyDoorAmounts(gameType, side, amount) {
  const table = LEGACY_DOORS[gameType]?.[side] ?? [];
  const result = /* @__PURE__ */ new Map();
  const ratioSum = table.reduce((sum, item) => sum + item.ratio, 0);
  if (ratioSum <= 0 || amount <= 0) return result;
  const minCoin = minCoinOf(gameType);
  const units = Math.floor(amount / minCoin);
  const exact = table.map((item) => units * item.ratio / ratioSum);
  const parts = exact.map(Math.floor);
  const order = exact.map((value, index) => ({ index, fraction: value - Math.floor(value) })).sort((x, y) => y.fraction - x.fraction || x.index - y.index);
  const remainder = units - parts.reduce((sum, part) => sum + part, 0);
  for (let i = 0; i < remainder; i += 1) {
    const target = order[i]?.index ?? 0;
    parts[target] = (parts[target] ?? 0) + 1;
  }
  table.forEach((item, index) => {
    result.set(item.key, (parts[index] ?? 0) * minCoin);
  });
  const first = table[0];
  if (first) result.set(first.key, (result.get(first.key) ?? 0) + (amount - units * minCoin));
  return result;
}
function cleanAmount(value) {
  const amount = Number(value);
  return Number.isFinite(amount) && amount > 0 ? Math.floor(amount) : 0;
}
function normalizeSideConfigs(raw, gameType) {
  const list = Array.isArray(raw) ? raw : [];
  const keys = BET_KEYS_BY_GAME[gameType];
  const bySide = /* @__PURE__ */ new Map();
  for (const entry of list) {
    const side = Object.values(AccountSide).find((value) => value === entry?.side);
    if (!side || !entry) continue;
    if (Array.isArray(entry.doors)) {
      const amounts = /* @__PURE__ */ new Map();
      for (const door of entry.doors) {
        const key = keys.find((value) => value === door?.key);
        if (key) amounts.set(key, cleanAmount(door?.amount));
      }
      bySide.set(side, amounts);
    } else if ("amount" in entry) {
      bySide.set(side, legacyDoorAmounts(gameType, side, cleanAmount(entry.amount)));
    }
  }
  return Object.values(AccountSide).map((side) => ({
    side,
    doors: keys.map((key) => ({ key, amount: bySide.get(side)?.get(key) ?? 0 }))
  }));
}

// src/utils/group-eligibility.ts
function classifyGroupAction(action, ctx) {
  if (action === "stop") {
    return ctx.running ? { ok: true } : { ok: false, reason: "kh\xF4ng ch\u1EA1y" };
  }
  if (ctx.running) return { ok: false, reason: "\u0111ang ch\u1EA1y" };
  if (ctx.issues.length > 0) return { ok: false, reason: ctx.issues.join("; ") };
  if (!ctx.allLoggedIn) return { ok: false, reason: "ch\u01B0a \u0111\u0103ng nh\u1EADp \u0111\u1EE7" };
  return { ok: true };
}

// src/utils/index.ts
function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
function isProduction(env = process.env.NODE_ENV ?? "development") {
  return env === "production";
}
function decodeBase64(str) {
  if (typeof atob === "function") {
    return atob(str);
  }
  if (typeof Buffer !== "undefined") {
    return Buffer.from(str, "base64").toString("utf-8");
  }
  throw new Error("Base64 decoding is not supported in this environment");
}
function decodeJwtPayload(jwt) {
  const parts = jwt.split(".");
  if (parts.length < 2 || !parts[1]) return void 0;
  try {
    const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64.padEnd(b64.length + (4 - b64.length % 4) % 4, "=");
    return JSON.parse(decodeBase64(padded));
  } catch {
    return void 0;
  }
}
export {
  REQUIRED_GROUP_MEMBERS,
  classifyGroupAction,
  decodeBase64,
  decodeJwtPayload,
  doorAmount,
  doorExposureWarning,
  groupIssues,
  isGroupRunnable,
  isProduction,
  normalizeSideConfigs,
  sideImbalanceWarning,
  sideKeyRatios,
  sideTotal,
  sleep,
  unsplittableSideWarning
};
//# sourceMappingURL=index.js.map